/**
 * Navigation configuration.
 *
 * Centralized definition of all navigation items, primary
 * actions, and footer structure. Consumed by the header,
 * mobile navigation, and footer components.
 */

export interface NavItem {
  label: string;
  path: string;
}

export const NAV_ITEMS: NavItem[] = [
  { label: 'About', path: '/about' },
  { label: 'Registry', path: '/registry' },
  { label: 'Standards', path: '/standards' },
  { label: 'How It Works', path: '/how-it-works' },
  { label: 'Resources', path: '/resources' },
  { label: 'FAQ', path: '/faq' },
];

export const NAV_LOGIN: NavItem = {
  label: 'Login',
  path: '/login',
};

export const NAV_CTA: NavItem = {
  label: 'Apply',
  path: '/apply',
};

export interface FooterLink {
  label: string;
  path: string;
}

export interface FooterColumn {
  title: string;
  links: FooterLink[];
}

export const FOOTER_COLUMNS: FooterColumn[] = [
  {
    title: 'Company',
    links: [
      { label: 'About', path: '/about' },
      { label: 'Registry', path: '/registry' },
      { label: 'Contact', path: '/contact' },
    ],
  },
  {
    title: 'Resources',
    links: [
      { label: 'Creator Resources', path: '/resources' },
      { label: 'FAQ', path: '/faq' },
      { label: 'Standards', path: '/standards' },
    ],
  },
  {
    title: 'Legal',
    links: [
      { label: 'Privacy', path: '/privacy' },
      { label: 'Terms', path: '/terms' },
    ],
  },
];

export const FOOTER_COMPANY = {
  name: 'UNIVIBE',
  description:
    'The Creator Registry & Professional Network. A carefully reviewed, professional community of verified creators across a growing global community.',
} as const;
